module.exports = __webpack_public_path__ + "img/2024-05.513f660c.jpg";